import { useCallback } from "react";
import { useSelector } from "react-redux";
import { QueryLayerServiceConfigurationDc } from "@evergis/api";

import { getProjectDataSources } from "../../../ducks/project/selectors";
import { useDataSources } from "./useDataSources";
import { FeatureAttribute } from "../../FeatureCard/components/Attributes/FeatureAttributeField";
import { ConfigContainerChild, ConfigDataSource, DataSourcePromise, SelectedFilters } from "../../FeatureCard/types";

export const useUpdateDataSource = ({
  dataSource,
  config,
  filters,
  attributes,
  layerParams,
  eqlParameters,
}: {
  dataSource: ConfigDataSource;
  config: ConfigContainerChild;
  filters: SelectedFilters;
  attributes?: FeatureAttribute[];
  layerParams?: Record<string, string>;
  eqlParameters?: QueryLayerServiceConfigurationDc["eqlParameters"];
}) => {
  const projectDataSources = useSelector(getProjectDataSources);
  const { getDataSourcePromises, getUpdatedDataSources } = useDataSources({
    config,
    filters,
    attributes,
    layerParams,
    eqlParameters,
  });

  return useCallback(
    async (newFilters: SelectedFilters, offset = 0) => {
      return getDataSourcePromises(dataSource, newFilters, offset).then((response: DataSourcePromise) => {
        const responseDataSources = getUpdatedDataSources([response], [dataSource], projectDataSources);

        return {
          items: responseDataSources.find(({ name }) => name === dataSource.name).features,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          totalCount: (response as any).totalCount,
        };
      });
    },
    [dataSource, getDataSourcePromises, getUpdatedDataSources, projectDataSources],
  );
};
